module.exports = __webpack_public_path__ + "img/EducationProgramKenya_3.cad7e493.jpg";